import '@cta/frontend';

import '@campact/camper/core/CmprAccordion';
import '@campact/camper/core/CmprProgressbar';
import '@campact/camper/core/CmprTicker';

import './index.scss';

import AppBoot from '@cta/frontend/javascripts/app_boot';
import App from './app.vue';

import { installErrorHandler } from '@appsignal/stimulus';
import appsignal from '@cta/shared/appsignal';
import { Application } from '@hotwired/stimulus';
import Rails from '@rails/ujs';
import DescriptionController from './controllers/description_controller';
import StickyTickerController from './controllers/sticky_ticker_controller';

Rails.start();

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('description', DescriptionController);
application.register('sticky-ticker', StickyTickerController);

AppBoot.start(App);
